var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4737 9H25C26.1046 9 27 9.89543 27 11V25C27 26.1046 26.1046 27 25 27H13C11.8954 27 11 26.1046 11 25V24.4286",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 9.5,
    r: 0.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19.1V21.8C5 22.4627 5.53726 23 6.2 23H21.8C22.4627 23 23 22.4627 23 21.8V6.2C23 5.53726 22.4627 5 21.8 5H6.2C5.53726 5 5 5.53726 5 6.2V14.6V19.1ZM5 19.1L10.4 12.8L15.2 18.8L18.8 15.8L23 19.1",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.38d6ccffef0394680b22142b76f1ee0a.svg";
export { ForwardRef as ReactComponent };